import { useLocation, Navigate, Outlet, useNavigate } from "react-router-dom";
import { useContext, useEffect } from "react";
import { Context } from "../../Context/Context";


const RequireAuth = ({ allowedRole }) => {
    const {userDetails} = useContext(Context);
    const location = useLocation();
    console.log("userDetails in require auth", allowedRole, userDetails?.role);
    return (
        allowedRole.includes(userDetails?.role)
            ? <Outlet />
            : userDetails?._id
                ? <Navigate to="/" state={{ from: location }} replace />
                 : <Navigate to="/signin" state={{ from: location }} replace />
    );
}

export default RequireAuth;